import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { AdvertisePartnerPrompt } from "@/components/layout/AdvertisePartnerPrompt";
import { CookieBanner } from "@/components/layout/CookieBanner";
import { NewsAlertWatcher } from "@/components/layout/NewsAlertWatcher";
import { NotificationPrompt } from "@/components/layout/NotificationPrompt";
import { PageViewTracker } from "@/components/layout/PageViewTracker";
import { PushSubscriptionSync } from "@/components/layout/PushSubscriptionSync";

function PageFallback() {
  return (
    <div
      className="flex min-h-[40vh] items-center justify-center text-sm text-brand-on-surface-variant"
      aria-busy="true"
    >
      Carregando…
    </div>
  );
}

export function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-brand-surface text-brand-ink">
      <PageViewTracker />
      <NewsAlertWatcher />
      <PushSubscriptionSync />
      <Header />
      <main className="portal-container flex-1 py-6 lg:py-8">
        <Suspense fallback={<PageFallback />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <CookieBanner />
      <NotificationPrompt />
      <AdvertisePartnerPrompt />
    </div>
  );
}
